// extracted by mini-css-extract-plugin
export default {"head":"style_head__qlImp","title":"style_title__rSiSW","time":"style_time__6lpsK","content":"style_content__gMdD2","tabs":"style_tabs__AsAWQ"};